/* eslint-disable */
import Colors from '../../Support/Theme/Colors/Colors'

const pendingChipStyles = ({ theme }) => ({
  chip: {
    color: Colors.gimblet[500],
    borderColor: Colors.gimblet[500],
  },
})

export default pendingChipStyles
